export const preferredCountries = ['gb', 'ie', 'us', 'ca', 'fi'];
